import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ComponentBase, DialogData, SelectCreateComponentStyle } from '@definitiv-packages/angular-dba-library';
import { Document, DocumentService } from '@definitiv-packages/angular-documents-library';
import { ProjectLanguage } from '../../types/ProjectLanguage';
import { RoofareaModelView } from '../../types/RoofareaModel';
import { SafetyPointModelView, SafetyPointModel } from '../../types/safety-point-model';
import { SafetyPointService } from '../../../lib/services/Models/safety-point-model.service';
import { RoofareaViewService } from '../../services/Views/RoofareaModelView.service'
import { DocumentDataType } from '../../types/document-data-type-enum';
import { FormModel, FormView, FormViewService } from '@definitiv-packages/angular-forms-library';
import { ScanService } from '../../../../../roofsafetymanagement-app/src/app/services/scan.service';
import { SicherungssystemModel, SicherungssystemModelView } from '../../types/SicherungssystemModel';
import { SicherungssystemModelService } from '../../services/Models/SicherungssystemModel.service'
import { CreateRoofareaComponent } from '../create-roofarea/create-roofarea.component';
import { ProjektPermissionService } from '../../services/projektpermission.service';
import { CreateSicherungssystemComponent } from '../create-sicherungssystem/create-sicherungssystem.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { DebitorModelView, DebitorViewService, ObjektModelView, ObjektViewService, StandortModelView, StandortService, StandortViewService } from '../../../public-api';
import { CreateStandortComponent } from '../create-standort/create-standort.component';
import { CreateObjektComponent } from '../create-objekt/create-objekt.component';
import { MemoryService } from '../../services/memory.service';
@Component({
  selector: 'app-create-safetypoint',
  templateUrl: './create-safetypoint.component.html',
  styleUrls: ['./create-safetypoint.component.scss'],
  standalone: false
})
export class CreateSafetyPointComponent extends ComponentBase<ProjectLanguage> implements OnInit, OnDestroy {

  /* diese Werte müssen aus einer Config geholt werden */
  public withelectronicID: boolean = false;
  public withassetlink: boolean = true;
  public withgeolocation: boolean = false;
  public widthformular: boolean = false;
  /*---------------------------------*/

  public Title: string = "";
  public safetyPoint: SafetyPointModelView;

  public debitorList: DebitorModelView[] = [];
  public standortList: StandortModelView[] = [];
  public selectedstandortModelView: StandortModelView | null = null;

  public objektList: ObjektModelView[] = [];
  public selectedobjektModelView: ObjektModelView | null = null;

  public roofareaList: RoofareaModelView[] = [];
  public selectedroofareaModelView: RoofareaModelView | null = null;

  public sicherungssystemList: SicherungssystemModelView[] = [];
  public selectedsicherungssystemModelView: SicherungssystemModelView | null = null;

  public isMobile: boolean = false;
  public selectedRoofArea: RoofareaModelView | null = null;

  public formList: FormView[] = [];
  public selectedForm: FormView | null = null;
  public documentList: Document[] = [];

  private DebitorControl: FormControl<DebitorModelView | null> = new FormControl<DebitorModelView | null>(null, [Validators.required]);
  private StandortControl: FormControl<StandortModelView | null> = new FormControl<StandortModelView | null>(null, [Validators.required]);
  private ObjektControl: FormControl<ObjektModelView | null> = new FormControl<ObjektModelView | null>(null, [Validators.required]);
  private RoofareaControl: FormControl<RoofareaModelView | null> = new FormControl(null, [Validators.required]);
  private SicherungssystemControl: FormControl<SicherungssystemModelView | null> = new FormControl(null, [Validators.required]);

  private BezeichnungControl: FormControl<string | null> = new FormControl(null, [Validators.required, Validators.maxLength(100)]);
  private ElectronicIdControl: FormControl<string | null> = new FormControl(null);
  private AssetLinkControl: FormControl<string | null> = new FormControl(null);

  public LongitudeControl: FormControl<number | null> = new FormControl(null, [Validators.min(-180), Validators.max(180), Validators.pattern(/^(-?\d{1,3})(\.\d{1,10})?$/)]);
  public LatitudeControl: FormControl<number | null> = new FormControl(null, [Validators.min(-90), Validators.max(90), Validators.pattern(/^(-?\d{1,3})(\.\d{1,10})?$/)]);

  private formControl: FormControl<FormModel | null> = new FormControl(null);

  public FormGroup = new UntypedFormGroup({
    debitorControl: this.DebitorControl,
    standortControl: this.StandortControl,
    objektControl: this.ObjektControl,
    roofAreaControl: this.RoofareaControl,

    sicherungssystemControl: this.SicherungssystemControl,
    electronicidControl: this.ElectronicIdControl,
    assetlinkControl: this.AssetLinkControl,

    description: this.BezeichnungControl,
    longitude: this.LongitudeControl,
    latitude: this.LatitudeControl,
    form: this.formControl
  });

  public styleList: SelectCreateComponentStyle<RoofareaModelView>[] = [
    { selectName: 'Bezeichnung', cssClass: 'alignleft' },
    { selectName: 'Strasse', cssClass: 'alignleft' },
    { selectName: 'PLZ', cssClass: 'alignleft' },
    { selectName: 'Ort', cssClass: 'alignleft' },
    { selectName: 'LandName', cssClass: 'alignleft' }
  ];

  private scanSubscription: Subscription;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData<SafetyPointModelView>,
    public dialogRef: MatDialogRef<CreateSafetyPointComponent>,
    public standortService: StandortService,
    public debitorService: DebitorViewService,
    public standortViewService: StandortViewService,
    public objektService: ObjektViewService,
    private safetypointService: SafetyPointService,
    private roofareaService: RoofareaViewService,
    private documentService: DocumentService,
    private formService: FormViewService,
    private scanService: ScanService,
    public deviceService: DeviceDetectorService,
    private dialog: MatDialog,
    public permissionService: ProjektPermissionService,
    private sicherungsService: SicherungssystemModelService,
    private memoryService: MemoryService
  ) {
    super();
    this.safetyPoint = data.data!;
    this.scanSubscription = this.scanService.safetyPoint.subscribe(electronicId => this.ElectronicIdControl.setValue(electronicId));
  }

  public async ngOnInit(): Promise<void> {
    this.loading = true;
    var resultList = await Promise.all([
      this.debitorService.getList(),
      this.standortViewService.getList(),
      this.objektService.getList(),
      this.roofareaService.getFilteredList(),
      this.formService.getFilteredList(),
      this.safetyPoint?.SafetyPointId ? this.documentService.getFilteredList({ DataTypeID: DocumentDataType.SafetyPoint, DataID: this.safetyPoint.SafetyPointId }) : Promise.resolve([]),
      this.sicherungsService.getFilteredList({})
    ]);

    if (this.data.mode == 'create') {
      this.Title = this.languageService.getText(this.language.safetypointerstellen);
    } else if (this.data.mode == 'edit') {
      this.Title = this.languageService.getText(this.language.safetypointbearbeiten);
    }


    this.isMobile = this.deviceService.getDeviceInfo().deviceType != "desktop";
    this.debitorList = resultList[0];
    this.standortList = resultList[1];
    this.objektList = resultList[2];
    this.roofareaList = resultList[3];

    this.formList = resultList[4];
    this.documentList = resultList[5];
    this.sicherungssystemList = resultList[6].sort((a, b) => {
      return (a.Bezeichnung < b.Bezeichnung) ? -1 : 1
    })

    if (!this.safetyPoint?.SafetyPointId && this.safetyPoint?.ObjektID) {
      this.roofareaList = resultList[3].filter(x => x.ObjektID == this.safetyPoint.ObjektID);
    }

    if (!this.safetyPoint?.SafetyPointId && this.safetyPoint?.RoofareaId) {
      this.roofareaList = resultList[3].filter(x => x.RoofareaID == this.safetyPoint.RoofareaId);
    }

    if (this.safetyPoint?.SafetyPointId) {


      this.DebitorControl.setValue(this.debitorList.find(x => x.DebitorID == this.safetyPoint.DebitorID)!);
      this.StandortControl.setValue(this.standortList.find(x => x.StandortID == this.safetyPoint.StandortID)!);
      this.ObjektControl.setValue(this.objektList.find(x => x.ObjektID == this.safetyPoint.ObjektID)!);


      this.RoofareaControl.setValue(this.roofareaList.find(x => x.RoofareaID == this.safetyPoint.RoofareaId)!);
      this.SicherungssystemControl.setValue(this.sicherungssystemList.find(x => x.SicherungssystemID == this.safetyPoint.SicherungssystemID)!);

      this.BezeichnungControl.setValue(this.safetyPoint.Bezeichnung);
      this.ElectronicIdControl.setValue(this.safetyPoint.ElectronicId);
      this.AssetLinkControl.setValue(this.safetyPoint.AssetLink);
      this.LongitudeControl.setValue(this.safetyPoint.Longitude);
      this.LatitudeControl.setValue(this.safetyPoint.Latitude);
      if (this.safetyPoint?.FormId) {
        var form = this.formList.find(x => x.FormId == this.safetyPoint.FormId);
        if (form) this.selectedForm = form;
      }
    } else {
      this.DebitorControl.setValue(this.memoryService.getDebitior(this.debitorList));
      this.StandortControl.setValue(this.memoryService.getStandort(this.standortList));
      this.ObjektControl.setValue(this.memoryService.getObjekt(this.objektList));
      this.RoofareaControl.setValue(this.memoryService.getRoofarea(this.roofareaList));
      this.SicherungssystemControl.setValue(this.memoryService.getSicherungssystem(this.sicherungssystemList));

      if (this.isMobile) {

        if (navigator.geolocation) {

          navigator.geolocation.getCurrentPosition((pos) => {
            this.LongitudeControl.setValue(Number(pos.coords.longitude.toFixed(10)));
            this.LatitudeControl.setValue(Number(pos.coords.latitude.toFixed(10)));
          },
            (error) => {
              alert(error)
            }, {
            enableHighAccuracy: true,
            timeout: 10000,
            maximumAge: 0
          }

          )

        } else {
          alert('Geolocation is not supported by this browser.');
        }
      }

    }

    this.ElectronicIdControl.valueChanges.subscribe(value => {
      this.ElectronicIdControl.setValue(value?.replace(/^#.*?#/, "") ?? '');
    })

    this.loading = false;
  }

  public ngOnDestroy(): void {
    this.scanSubscription.unsubscribe();
    this.memoryService.Debitor = this.DebitorControl.value;
    this.memoryService.Standort = this.StandortControl.value;
    this.memoryService.Objekt = this.ObjektControl.value;
    this.memoryService.Roofarea = this.RoofareaControl.value;
    this.memoryService.Sicherungssystem = this.SicherungssystemControl.value;
  }

  public async Save(): Promise<void> {
    this.FormGroup.markAllAsTouched();
    this.FormGroup.updateValueAndValidity();
    if (!this.FormGroup.valid) return;

    var safetypoint = new SafetyPointModel();
    if (this.data.mode == 'edit' && this.data.data) safetypoint.SafetyPointId = this.data.data.SafetyPointId;

    safetypoint.ElectronicId = this.ElectronicIdControl.value;
    safetypoint.AssetLink = this.AssetLinkControl.value;
    safetypoint.Bezeichnung = this.BezeichnungControl.value!;
    safetypoint.Longitude = this.LongitudeControl.value;
    safetypoint.Latitude = this.LatitudeControl.value;
    safetypoint.FormId = this.selectedForm ? this.selectedForm.FormId : null;

    try {

      this.loading = true;

      if (this.SicherungssystemControl.value) {
        safetypoint.SicherungssystemID = this.SicherungssystemControl.value.SicherungssystemID!;
      } else {

        var Obj = new SicherungssystemModel();
        Obj.RoofareaID = this.RoofareaControl.value?.RoofareaID!;
        Obj.Bezeichnung = this.BezeichnungControl.value!;
        var Sicherungssystem = await this.sicherungsService.post(Obj);
        safetypoint.SicherungssystemID = Sicherungssystem.SicherungssystemID;
      }

      var item = safetypoint.SafetyPointId ? await this.safetypointService.put(safetypoint.SafetyPointId, safetypoint) : await this.safetypointService.post(safetypoint);
      await this.documentService.setList(DocumentDataType.SafetyPoint, item.SafetyPointId, this.documentList);

      this.clearForm();


      this.loading = false;

      if (this.data.mode == 'edit')
        this.dialogRef.close(item)

    } catch {
      this.loading = false;
    }
  }

  private clearForm() {
    this.documentList = [];
    this.BezeichnungControl.setValue("");
    this.ElectronicIdControl.setValue("");
    this.AssetLinkControl.setValue("");
    this.LatitudeControl.setValue(null);
    this.LongitudeControl.setValue(null);
  }
  public openMaps(): void {
    var adress = this.LatitudeControl.value + "," + this.LongitudeControl.value;
    const url = "https://www.google.com/maps/search/?api=1&query=" + adress;
    window.open(url, '_blank');
  }

  public formatLongitude(): void {
    const ctrl = this.FormGroup.get('longitudeControl');
    if (ctrl?.value !== null) {
      ctrl?.setValue(Number(ctrl.value).toFixed(10), { emitEvent: false });
    }
  }

  public formatLatitude(): void {
    const ctrl = this.FormGroup.get('latitudeControl');
    if (ctrl?.value !== null) {
      ctrl?.setValue(Number(ctrl.value).toFixed(10), { emitEvent: false });
    }
  }

  getSicherungssysteme(): SicherungssystemModelView[] {

    if (!this.RoofareaControl.value?.RoofareaID) return [];
    return this.sicherungssystemList.filter(x => x.RoofareaID == this.RoofareaControl.value?.RoofareaID);
  }




  getfilterStandortList() {
    if (!this.DebitorControl.value?.DebitorID) return [];
    return this.standortList.filter(x => x.DebitorID == this.DebitorControl.value?.DebitorID);
  }
  public OpenCreateStandortDialog = (): Promise<StandortModelView> => {
    return new Promise<StandortModelView>((resolve, reject) => {

      var StandortModelView: StandortModelView = {
        StandortID: 0,
        DebitorID: this.DebitorControl.value?.DebitorID!,
        Strasse: "",
        PLZ: "",
        Ort: "",
        LandID: null,
        Bezeichnung: ""
      }

      var data = new DialogData(StandortModelView, 'create');
      this.dialog.open(CreateStandortComponent, { data: data }).afterClosed().subscribe((item: StandortModelView) => {
        if (item) {
          this.standortList.push(item);
        }

        resolve(item);
      });

    });
  }

  getfilterObjektList() {
    if (!this.StandortControl.value?.StandortID) return [];
    return this.objektList.filter(x => x.StandortID == this.StandortControl.value?.StandortID);
  }

  public OpenCreateObjektDialog = (): Promise<ObjektModelView> => {
    return new Promise<ObjektModelView>((resolve, reject) => {

      var ObjektModelView: ObjektModelView = {
        DebitorID: this.DebitorControl.value?.DebitorID!,
        StandortID: this.StandortControl.value?.StandortID!,
        Strasse: "",
        PLZ: "",
        Ort: "",
        Bezeichnung: ""
      }

      var data = new DialogData(ObjektModelView, 'create');
      this.dialog.open(CreateObjektComponent, { data: data }).afterClosed().subscribe((item: ObjektModelView) => {
        if (item) {
          this.objektList.push(item);
        }

        resolve(item);
      });

    });
  }

  getfilterRoofareaList() {
    if (!this.ObjektControl.value?.ObjektID) return [];
    return this.roofareaList.filter(x => x.ObjektID == this.ObjektControl.value?.ObjektID);
  }
  public OpenCreateRoofareaDialog = (): Promise<RoofareaModelView> => {
    return new Promise<RoofareaModelView>((resolve, reject) => {

      var roofareaModelView: RoofareaModelView = {
        DebitorID: this.DebitorControl.value?.DebitorID!,
        StandortID: this.StandortControl.value?.StandortID!,
        ObjektID: this.ObjektControl.value?.ObjektID!,

        Bezeichnung: "",

      }

      var data = new DialogData(roofareaModelView, 'create');
      this.dialog.open(CreateRoofareaComponent, { data: data }).afterClosed().subscribe((item: RoofareaModelView) => {
        resolve(item);

      });
    });
  }

  public OpenCreateSicherungssystemDialog = (): Promise<SicherungssystemModelView> => {
    return new Promise<SicherungssystemModelView>((resolve, reject) => {


      var sicherungssystemModelView: SicherungssystemModelView = {
        DebitorID: this.DebitorControl.value?.DebitorID!,
        StandortID: this.StandortControl.value?.StandortID!,
        ObjektID: this.ObjektControl.value?.ObjektID!,
        RoofareaID: this.selectedRoofArea?.RoofareaID!,
        Bezeichnung: ""
      }

      var data = new DialogData(sicherungssystemModelView, 'create');
      this.dialog.open(CreateSicherungssystemComponent, { data: data }).afterClosed().subscribe((item: SicherungssystemModelView) => {
        if (item) {
          this.sicherungssystemList.push(item);
          resolve(item);
        }

      });
    });
  }

  isValidUrl(url: string | null | undefined): boolean {
    if (!url) {
      return false;
    }

    try {
      new URL(url);
      return true;
    } catch {
      return false;
    }
  }

  openLink(url: string): void {
    if (this.isValidUrl(url)) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  }
  get assetLinkControl() {
    return this.FormGroup.get('assetlinkControl');
  }
}
